import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Header from 'common/Header';
import IdleTimer from 'services/IdleTimer';
import './layout.css';

export class Layout extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]).isRequired,
  }

  componentDidMount() {
    IdleTimer.init();
  }

  componentWillUnmount() {
    IdleTimer.cleanUp();
  }

  render() {
    const { children } = this.props;
    return (
      <div className="flex flex-column w-100 h-100">
        <Header />
        {children}
      </div>
    );
  }
}

export default Layout;
